import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterSpamFeedback = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterSpamFeedback'),
);
